import { useBreakpointValue } from '@chakra-ui/react';
import type { Layout } from '../ui/theme/tokens/breakpoints';

/**
 * Current app layout state. Drive shell and primitive variants off this —
 * not ad-hoc pixel checks.
 *
 *   mobile  < 1024   hamburger nav, stacked chrome, full-bleed drawers
 *   laptop  ≥ 1024   persistent rail, compact density
 *   desktop ≥ 1280   full chrome
 *
 * Fallback is laptop so the common work surface doesn't flash a hamburger
 * on first paint.
 */
export function useLayout(): Layout {
	return (
		useBreakpointValue<Layout>(
			{ base: 'mobile', lg: 'laptop', xl: 'desktop' },
			{ ssr: false, fallback: 'lg' },
		) ?? 'laptop'
	);
}

/** True on the mobile layout: left rail is an overlay hamburger drawer. */
export function useOverlayNav(): boolean {
	return useLayout() === 'mobile';
}

export default useLayout;
